/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Date_WarningInputs */



/**
* | output |
* | --- |
* | "Please provide a start and end date for custom queries." |
*
* @param {Custom_Date_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_date_warning = /** @type {((inputs?: Custom_Date_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Date_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez fournir une date de début et de fin pour les requêtes personnalisées.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie für individuelle Anfragen ein Start- und Enddatum an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per le query personalizzate, specificare una data di inizio e di fine.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, укажите начальную и конечную даты для пользовательских запросов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proporcione una fecha de inicio y finalización para consultas personalizadas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请为自定义查询提供开始日期和结束日期。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムクエリの開始日と終了日を指定してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया कस्टम क्वेरी के लिए प्रारंभ और समाप्ति तिथि प्रदान करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, indique uma data de início e uma data de término para consultas personalizadas.")
	return /** @type {LocalizedString} */ ("Please provide a start and end date for custom queries.")
});